import { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation, Router } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Sidenav from "components/Sidenav";
import theme from "assets/theme";
import routes from "routes";
import { useSoftUIController, setMiniSidenav } from "context";
import brand from "assets/images/logo.png";
import { APP_CONSTANTS } from "App.constant";

export default function App() {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, direction, layout, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();
  const [basePath, setBasePath] = useState('/');
  const USERTYPE = JSON.parse(localStorage.getItem('userData')) ? JSON.parse(localStorage.getItem('userData'))['user_type']: 0;

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  useEffect(() => {
    document.body.setAttribute("dir", direction);
    if (localStorage.getItem('isLoggedIn') !== null && localStorage.getItem('isLoggedIn').toString() === 'true') {
      setBasePath('/dashboard');
    }
  }, [direction]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (
        route.route &&
        (
          USERTYPE === APP_CONSTANTS.USER_ROLES.ADMIN ||
          route.access_type === APP_CONSTANTS.USER_ROLES.ALL ||
          (
            route.access_type !== APP_CONSTANTS.USER_ROLES.ALL &&
            USERTYPE !== APP_CONSTANTS.USER_ROLES.ADMIN &&
            USERTYPE === route.access_type  
          )
        )
      ) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return <ThemeProvider theme={theme}>
    <CssBaseline />
    {layout === "dashboard" && (
      <>
        <Sidenav
          color={sidenavColor}
          brand={brand}
          brandName="Consumer Sketch"
          brandUrl={basePath}
          routes={routes}
          onMouseEnter={handleOnMouseEnter}
          onMouseLeave={handleOnMouseLeave}
        />
      </>
    )}
    <Routes>
      {getRoutes(routes)}
      <Route path="*" element={<Navigate to={basePath} />} />
    </Routes>
  </ThemeProvider>;
}
